
import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UserHeaderProps {
  userName: string;
  onBack: () => void;
}

export const UserHeader: React.FC<UserHeaderProps> = ({ userName, onBack }) => {
  return (
    <header className="bg-[#BD1E28] text-white p-4">
      <div className="flex items-center">
        <Button 
          variant="ghost" 
          className="mr-3 p-0 hover:bg-transparent text-white"
          onClick={onBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-lg font-bold">Détails de l'utilisateur</h1>
      </div>
    </header>
  );
};
